import React, { useEffect, useState, useRef } from "react"
import MetaTags from 'react-meta-tags';
import { Container } from "reactstrap"
import { useSelector, useDispatch } from "react-redux";
import Loader from "components/Common/Loader"
import SimpleBar from "simplebar-react"
import {
  Card,
  CardBody,
  CardTitle,
  CardText,
  CardHeader,
  Table,
  Row,
  Col,
  Badge,
  Spinner,
  Button,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Dropdown,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import * as moment from "moment"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import InvoiceDetailV4 from "../../components/Common/InvoiceDetailV4"
import SalesListFilter from "../../components/Common/SalesListFilter"
import { getSalesEntryList } from "helpers/backend_helper"

import { getSgstArray, getCgstArray, getIgstArray } from "helpers/function_helper"
import { getSalesEntryForEditDirect } from "helpers/backend_helper"
import { useReactToPrint } from "react-to-print";
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import { getStoreDetailsFromCache } from "helpers/cache_helper"

const SalesEntryListDetails = (props) => {

  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    //pageStyle : "@page { size: 2.5in 4in }",
    content: () => componentRef.current
  });

  const dispatch = useDispatch()

  const [filterApplied, setFilterApplied] = useState(false)
  const [searchCriteria, setSearchCriteria] = useState({})
  const [searchDispCriteria, setSearchDispCriteria] = useState({
    customername: 'All',
    status : 'Any'
  })

  const [salesEntryList, setSalesEntryList] = useState([])
  const [salesEntry, setSalesEntry] = useState({})
  const [customerDetails, setCustomerDetails] = useState({})
  const [showLoading, setShowLoading] = useState(false)
  const [searchInProgress, setSearchInProgress] = useState(false)
  const [storeDetails, setStoreDetails] = useState({})
  const [selectedItem, setSelectedItem] = useState()

  useEffect(() => {
    //dispatch(onGetAllCustomers())
    dispatch(onGetStoreSettings(true))
    fetchStoreDetails()
  }, [dispatch]);

  const { customerList, settings } = useSelector(state => ({
    settings: state.Products.settings
  }))

  useEffect(() => {
    setSalesEntryList(props.salesEntryList)
  }, [props.salesEntryList])

  useEffect(() => {
    if(props.filterApplied != undefined){
      setFilterApplied(props.filterApplied)
    }
    if(props.searchCriteria){
      setSearchCriteria(props.searchCriteria)
    }
    if(props.searchDispCriteria){
      setSearchDispCriteria(props.searchDispCriteria)
    }
  }, [props]);

  useEffect(() => {
    //console.log('props.selectedRow::'+JSON.stringify(props.selectedRow))
    if(props.selectedRow && props.selectedRow.id){
      setSelectedItem(props.selectedRow.id)
      getSalesEntryDetails(props.selectedRow)
      setCustomerDetails({
        name:props.selectedRow.custname,
        address:props.selectedRow.custaddress,
        mobile:props.selectedRow.custmobile,
        phone:props.selectedRow.custphone,
        email:props.selectedRow.custemail,
        gstin:props.selectedRow.custgstin,
        statename:props.selectedRow.custstatename,
        statecode:props.selectedRow.custstatecode,
      })
    }
  }, [props.selectedRow])

  function close(){
    props.hideReceipt()
  }

  /*salesEntryList={salesEntryList} selectedRow={selectedRow}*/

  async function getSalesEntryDetails(item){
    setCustomerDetails({
      name:item.custname,
      address:item.custaddress,
      mobile:item.custmobile,
      phone:item.custphone,
      email:item.custemail,
      gstin:item.custgstin,
      statename:item.custstatename,
      statecode:item.custstatecode,
    })
    setShowLoading(true)
    const response = await getSalesEntryForEditDirect(item.id)
    if(response && response.status === 'failure'){
    }
    else if(response && response.id){
      let sgstArray = getSgstArray(response.salesRows)
      let cgstArray = getCgstArray(response.salesRows)
      let igstArray = getIgstArray(response.salesRows)
      
      response["sgstArray"] = sgstArray
      response["cgstArray"] = cgstArray
      response["igstArray"] = igstArray
      setSalesEntry(response)
      scrollToBottom()
    }
    setShowLoading(false)
  }

  const handleValidDate = date => {
    const date1 = moment(new Date(date)).format("DD MMM Y")
    return date1
  }
  
  function fetchStoreDetails(){
    getStoreDetailsFromCache(true).then(resp =>{
      setStoreDetails(resp)
    })
  }

  function toLowerCase(str){
    if(str){
      return str.toLowerCase()
    }
  }

  

  function onSearch(searchCritiria){
    setSearchCriteria(searchCritiria)
    setSearchInProgress(true)
    getSalesEntryList(searchCritiria).then(result => {
      setSalesEntryList(result)
      setSearchInProgress(false)
    })
  }

  return (
    <React.Fragment>
      <div className="">
        <Container fluid>
          <Breadcrumbs title="Sales" breadcrumbItem="All Sales " />

          <Card>
            <CardBody className="no-x-padding">
              <Row className="no-gutters">
                <Col>
                  
                  <SalesListFilter 
                    filterApplied={filterApplied}
                    setFilterApplied={setFilterApplied}
                    searchCriteria={searchCriteria}
                    searchDispCriteria={searchDispCriteria}
                    setSearchDispCriteria={setSearchDispCriteria}
                    onSearch={onSearch} 
                    searchInProgress={searchInProgress}/>

                  <SimpleBar style={{ maxHeight: "550px" , paddingBottom:"30px"}} autoHide={false}>
                  {salesEntryList.map((entry, i) => (
                    <React.Fragment key={i}>
                    {selectedItem == entry.id ? <div ref={messagesEndRef} />: null}
                    <div className={selectedItem == entry.id ? "pointer-cursor-with-hover px-2 bg-light-blue" : "pointer-cursor-with-hover px-2 "} onClick={()=>{
                      getSalesEntryDetails(entry)
                      setSelectedItem(entry.id)
                    }}>
                      <Row className="py-2">
                        <Col className="font-size-13">
                          {entry.custname}
                        </Col>
                        <Col>
                          <span className="float-end"><i className="bx bx-rupee font-size-13"></i>{Number(entry.grandtotal).toLocaleString('en-IN',{minimumFractionDigits: 2})}</span>
                        </Col>
                      </Row>
                      <Row className="py-2 border-bottom">
                        <Col>
                          {handleValidDate(entry.invoicedate)}
                        </Col>
                        <Col className="text-center">
                          {entry.invoiceno}
                        </Col>
                        <Col className="text-end">
                          <Badge className={entry.status == "PAID"? "font-size-12 bg-success badge-success":"font-size-12 bg-warning badge-warning"}>
                            {entry.status}
                          </Badge>
                        </Col>
                      </Row>
                    </div>
                    </React.Fragment>
                    
                  ))}
                    
                  </SimpleBar>
                  {(!searchInProgress && salesEntryList.length == 0) && 
                    <Card color="warning" >
                    <CardBody>
                      <CardText className="font-size-16">
                        <i className="bx bx-sad me-1" /> Sorry, nothing found !!!
                      </CardText>
                    </CardBody>
                  </Card>
                  }
                </Col>
                <Col>
                {showLoading ? 
                <div className="print-page-a4 text-center">
                  <Spinner style={{ width: '3.2rem', height: '3.2rem' }} className="ms-3" color="primary" /> 
                </div>
                : 
                <>
                <Row className="py-4">
                  <Col className="text-center">
                    <div className={"currentstatus-"+toLowerCase(salesEntry.status)}>
                    {salesEntry.status}
                  </div>
                  </Col>
                  <Col className="text-end">
                    <Button className="btn btn-sm w-md" onClick={() => {
                        handlePrint()
                      }}
                      >
                      <i className="bx bx-printer me-1"></i>
                      Print
                    </Button>

                    <Button className="btn btn-sm ms-1" onClick={() => {
                        close()
                      }}
                      >
                      <i className="fas fa-window-close"></i>
                    </Button>
                  </Col>
                </Row>
                
                <SimpleBar style={{ maxHeight: "550px", width:"21cm", paddingBottom:"30px"}}>
                  <InvoiceDetailV4 
                    salesDetails={salesEntry}
                    storeDetails={storeDetails}
                    customerDetails={customerDetails}
                    fromSales={false}
                    settings={settings}
                    ref={componentRef}
                  />
                </SimpleBar>
                
                  </>
                  }
                </Col>
              </Row>
              
            </CardBody>

          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SalesEntryListDetails
